const config= {
    api_key: "AIzaSyCa5lQ9iVDk8mrlNy_43htcm6bCAb2vh-U",
    channel_id: "UCRVceboNw0A6hrbd538AGFA"
}

export default config;